export default {"src":"/_next/static/media/policy-development.437db323.svg","height":847,"width":657,"blurWidth":0,"blurHeight":0};